import React, { useContext } from "react"
import styled from "styled-components"
import { ThemeContext } from "Components"
import { theme } from "Theme"
import { Utils } from "Components"

export const Content = styled.div`
  display: block;
  padding: 4rem 1rem;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  color: ${({ mode }) => (mode === "dark" ? theme.colors.white.base : theme.colors.black.base)};
  background-color: ${({ mode }) => (mode === "dark" ? theme.colors.black.base : theme.colors.white.base)};
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 4rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const ActionsBlock = styled.div`
  color: ${({ mode }) => (mode === "dark" ? theme.colors.white.base : theme.colors.black.base)};
  background-color: ${({ mode }) => (mode === "dark" ? theme.colors.black.base : theme.colors.white.base)};
  padding: 2rem 1rem;
  border-radius: ${theme.borderRadius.ui};
  box-shadow: ${theme.shadow.feature.small.default};
  border-left: ${({ color }) => (color ? `4px solid ${Utils.BrandColor(color)}` : `0px solid transparent`)};
`

const CardBlock = ({ color, children }) => {
  const { mode } = useContext(ThemeContext)
  return (
    <ActionsBlock color={color} mode={mode}>
      {children}
    </ActionsBlock>
  )
}

export default CardBlock
